export const LOGIN_SUCCESS = 'login/success';